import React, { useMemo } from 'react';

// Components
import * as S from '../Styled';
import Selecter from '../../Selecter';
import Icon from '../../Icon';
import User from '../User';
import { Button } from '../../Button';

// Store
import { useDispatch, useSelector } from 'react-redux';

// Utils
import localStorage from 'store';
import { getUserType, getValueStorage } from '../../../utils';
import { useHistory } from 'react-router-dom';

// Config
import { menu } from '../../../config/menu';
import { profileNav } from '../../../actions';
import { useTranslation } from 'react-i18next';

const Panel = ({ onLoginModal, onCart }) => {
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useSelector(state => state.auth);

  const favoritesSize = useSelector(state => state.user.favorites.length);
  const cartSize = useSelector(state => state.cart.items.length);
  const history = useHistory();
  const { profileNavIsVisible } = useSelector(state => state.ui);
  const insurances = useMemo(() => {
    if (!isAuthenticated) {
      return null;
    }

    if (isAuthenticated) {
      return user?.insurances;
    }
  }, [user, isAuthenticated]);
  let currentUser = getUserType();
  let userInsurance = currentUser === 'insurance';
  let { t } = useTranslation();

  const handleInsurance = item => {
    localStorage.set(
      'insurance_item',
      insurances.find(insurance => insurance.title === item)
    );
    history.go();
  };

  let activeItem = getValueStorage('insurance_item');

  const handleProfile = () => dispatch(profileNav(!profileNavIsVisible));

  return (
    <S.Panel>
      {insurances !== null && insurances.length > 0 ? (
        <S.ItemDesktop className="insurance">
          {insurances.length === 1 ? (
            <S.Insurance>{insurances[0].title}</S.Insurance>
          ) : (
            <Selecter
              items={insurances}
              onSelect={item => handleInsurance(item)}
              fontSize="13px"
              activeItem={activeItem}
            />
          )}
        </S.ItemDesktop>
      ) : null}

      <S.Item className="favorites">
        <S.StyledUserLink to="/favorites">
          <S.CounterIcon>
            <Icon name="heart" size="small" />
            {favoritesSize ? <S.Count>{favoritesSize}</S.Count> : null}
          </S.CounterIcon>
          <S.Label>{t('labels.favorites')}</S.Label>
        </S.StyledUserLink>
      </S.Item>

      {isAuthenticated ? (
        <S.ItemMobile>
          <S.StyledUserLink to="#" onClick={handleProfile}>
            <Icon name="user" size="small" />
          </S.StyledUserLink>
        </S.ItemMobile>
      ) : null}

      <S.Item className="cart">
        <S.StyledUserLink to="" onClick={onCart}>
          <S.CounterIcon>
            <Icon name="cart" size="small" />
            {cartSize ? <S.Count>{cartSize}</S.Count> : null}
          </S.CounterIcon>
          <S.Label>{t('labels.shopping_cart')}</S.Label>
        </S.StyledUserLink>
      </S.Item>

      {userInsurance ? (
        <S.ItemDesktop className="thunder">
          <S.StyledUserLink to="/order/cart">
            <S.CounterIcon>
              <Icon name="energy" size="small" />
            </S.CounterIcon>
            <S.Label>{t('labels.quick_order')}</S.Label>
          </S.StyledUserLink>
        </S.ItemDesktop>
      ) : null}

      <S.ItemDesktop>
        {!isAuthenticated ? (
          <Button type="shading" htmlType="button" onClick={onLoginModal}>
            {t('buttons.log_in')}
          </Button>
        ) : (
          <User icon="user" menu={menu} />
        )}
      </S.ItemDesktop>
    </S.Panel>
  );
};

export default Panel;
